import Slider from "../components/Slider"
import {useEffect, useState} from "react";
import org_api from "../api/admin/admin_orgs"



const CommercialValuationRequestsToggle = (props) => {

    const [enableCommercialValuations, setEnableCommercialValuations] = useState(true)
    const [enableUpdate, setEnableUpdate] = useState(false)

    useEffect(() => {
        getCommercialValuations()
        setEnableUpdate(true)
    }, []);

    useEffect(() => {
        updateCommercialValuations()
    }, [enableCommercialValuations]);

    const updateCommercialValuations = () => {
        if(!enableUpdate) return;
        org_api.putCommercialValuations(props.org_id, {
            "commercial_valuations": enableCommercialValuations
        })
    }

    const getCommercialValuations = () => {
        let response = org_api.getCommercialValuations(props.org_id)
        response.then(response => setEnableCommercialValuations(response.data))
    }

    return (
        <div className="commercial-valuation-requests-toggle-container">
            <div className="commercial-valuation-requests-toggle-title">Commercial valuations</div>
            <div className="commercial-valuation-requests-toggle">
                <Slider state={enableCommercialValuations} update={setEnableCommercialValuations.bind(this)}
                        text="Allow commercial valuation requests"
                />
            </div>
        </div>
    )
}


export default CommercialValuationRequestsToggle